import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup5 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group5';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'partner-analysis-group5-lov',
    templateUrl: './partner-analysis-group5-lov.component.html',
    styleUrls: ['./partner-analysis-group5-lov.component.scss']
})


export class PartnerAnalysisGroup5LovComponent extends GenericLovComponent   {

    @Input() code         : string; 
    @Input() name         : string; 

    partnerAnalysisGroup5s: PartnerAnalysisGroup5[] = [];

    columns = [
        {  prop: 'partnerAnalysisGroup5Code', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PartnerAnalysisGroup5LovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "partnerAnalysisGroup5";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.partnerAnalysisGroup5s = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : PartnerAnalysisGroup5){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
